import React from "react";

// SellePack official mark — isometric navy package with green shield + white check.
// Re-rendered as crisp inline SVG so it scales cleanly at any size and matches
// the brand colors: navy #0F2A5C, green #2EB358, white check.
function SellepackBadge({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="SellePack"
      data-testid="brand-badge-svg"
    >
      {/* Top lid (back) */}
      <path d="M14 18 L32 9 L50 18 L32 27 Z" fill="#0F2A5C" />
      {/* Top lid open flap (lighter navy) */}
      <path d="M22 13.5 L32 8 L42 13.5 L32 19 Z" fill="#1B3D7A" />
      {/* Right side (deep navy) */}
      <path d="M50 18 L50 46 L32 56 L32 27 Z" fill="#0F2A5C" />
      {/* Left side (slightly lighter for depth) */}
      <path d="M14 18 L14 46 L32 56 L32 27 Z" fill="#16356B" />
      {/* Green shield in front-left face */}
      <path
        d="M19 28 L29 24 L29 40 C29 44.5 25.4 47.5 24 48 C22.6 47.5 19 44.5 19 40 Z"
        fill="#2EB358"
      />
      {/* White checkmark inside shield */}
      <path
        d="M21.5 36.5 L23.6 38.6 L27 33.6"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function BrandLogo({ size = 28, label = true, tenant, tagline = true }) {
  const name = tenant?.name || "SellePack";
  // Allow tenant override but default to navy
  const navy = tenant?.brand_color || "#0F2A5C";
  const green = "#2EB358";

  if (tenant?.logo_url) {
    return (
      <div className="flex items-center gap-2" data-testid="brand-logo">
        <img src={tenant.logo_url} alt={name} style={{ height: size }} />
        {label && (
          <div className="flex flex-col leading-none">
            <span className="font-display text-xl font-black tracking-tighter">{name}</span>
            {tagline && (
              <span className="text-[9px] tracking-[0.18em] uppercase mt-0.5" style={{ color: navy }} data-testid="brand-tagline">
                Global Solutions / Protected !!
              </span>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <SellepackBadge size={size} />
      {label && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-xl font-black tracking-tighter" data-testid="brand-wordmark">
            <span style={{ color: navy }}>Selle</span>
            <span style={{ color: green }}>Pack</span>
          </span>
          {tagline && (
            <span
              className="text-[9px] tracking-[0.18em] uppercase mt-0.5"
              style={{ color: navy }}
              data-testid="brand-tagline"
            >
              Global Solutions / Protected !!
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export { SellepackBadge };
